export class ReportRelease {
    EMAIL: string;
    NAME: string;

    static parse(json: any): ReportRelease {
        if (json) {
            const rr = new ReportRelease();
            rr.EMAIL = json.EMAIL;
            rr.NAME = json.NAME;

            return rr;
        } else { return null; }
    }

    static parseArray(json: Array<any>): Array<ReportRelease> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(ReportRelease.parse(j));

        return arr;
    }
}
